import { Button } from 'components/Button';
import React from 'react';
import './footer.scss';

export const EndFooter = () => {
  return (
    <div className="endFooter">
      <h1 style={{ color: 'black', textAlign: 'center' }}>Wanna talk to me?</h1>
      <div style={{ height: '32px' }} />
      <h3 style={{ color: 'black', textAlign: 'center' }}>
       
      </h3>{' '}
      <div style={{ height: '32px' }} />
      <Button iconHoverShift href="/contact" iconEnd="arrowRight" footerButton={true}>
       Click here!{' '}
      </Button>
    </div>
  );
};


